// Static client reviews — frontend only, no backend.
export const REVIEWS = [
  {
    id: "r1",
    author: "Sofiane B.",
    role: "Clio IV — Pack complet",
    initials: "SB",
    rating: 5,
    comment:
      "Intervention à domicile impeccable. La voiture est comme neuve, intérieur et extérieur. Ponctuel et très soigneux.",
  },
  {
    id: "r2",
    author: "Marie L.",
    role: "Canapé d'angle + matelas",
    initials: "ML",
    rating: 5,
    comment:
      "J'ai fait nettoyer mon canapé et un matelas. Résultat bluffant, les taches ont disparu et le séchage a été rapide.",
  },
  {
    id: "r3",
    author: "Karim D.",
    role: "Formule Concession — SUV",
    initials: "KD",
    rating: 5,
    comment:
      "La formule Concession vaut largement son prix. Plastiques rénovés, traitement hydrophobe nickel. Je recommande.",
  },
  {
    id: "r4",
    author: "Élodie R.",
    role: "Vidange + freinage",
    initials: "ER",
    rating: 5,
    comment:
      "Devis clair et honnête pour une vidange et les plaquettes. Travail propre et explications claires. Au top.",
  },
  {
    id: "r5",
    author: "Thomas P.",
    role: "208 — Intérieur simple",
    initials: "TP",
    rating: 5,
    comment:
      "Réservation hyper simple via WhatsApp. Habitacle parfaitement nettoyé, aspiration en profondeur. Rien à redire.",
  },
  {
    id: "r6",
    author: "Nadia K.",
    role: "Fauteuils + chaises",
    initials: "NK",
    rating: 5,
    comment:
      "Service textile à domicile rapide et efficace. Mes fauteuils ont retrouvé leur couleur d'origine. Merci !",
  },
];
